import React from 'react';
import {Card} from "react-bootstrap";

import {FaChevronRight, FaPlus, FaTrashAlt} from "react-icons/fa";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import ProgressBar from "./ProgressBar";
import ConfirmDelete from "./ConfirmDelete";

function MenuItem(props) {
    const body = <Card className="bg-lightblue px-2 py-4">
        <div className="d-flex align-items-center justify-content-start px-lg-4">

            <div style={{width: '80px'}} className="me-3 me-lg-4">
                <ProgressBar delay={props?.delay} now={props.progress}/>
            </div>
            <div className="flex-fill">
                {props.title}
            </div>
            {
                props.editing && (
                    <ConfirmDelete id={props.id} onDelete={props.remove} className="btn btn-secondary btn-sm my-0 py-0" >
                        <FaTrashAlt/>
                    </ConfirmDelete>
                )
            }
            {
                !props.editing && (<FaChevronRight className="ms-3"/>)
            }
        </div>

    </Card>
    if (!!props?.add){
        return <Card className="cursor-pointer hoverable bg-lightblue px-2 py-4" onClick={props.add}>
            <div className="d-flex align-items-center justify-content-start px-lg-4">

                <div style={{width: '80px'}} className="me-3 me-lg-4"/>
                <div className="flex-fill">
                    {props.title}
                </div>
                {!!props?.editing && (
                    <button className="btn btn-secondary btn-sm my-0 py-0"><FaPlus className="ms-3"/></button>
                )}
                {!props?.editing && <FaPlus className="ms-3"/>}
            </div>
        </Card>
    }

    return props.editing ? body : (
        <Link className="" to={props.link}>
            {body}
        </Link>
    )
}
MenuItem.propTypes = {
    progress: PropTypes.number,
    delay: PropTypes.number,
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    // for deletion
    remove: PropTypes.func,
    add: PropTypes.func,
    editing: PropTypes.bool,
    id: PropTypes.string
};
export default MenuItem;